import { render } from "./switch.vue?vue&type=template&id=2f4b40ee&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import "./switch.vue?vue&type=style&index=0&id=2f4b40ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4b40ee"]])

export default __exports__